export default "__VITE_ASSET__9b41ecb7__"